import Home from '@/views/Home.vue';
import auth from '../middleware/auth';

const homeRoutes = [
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      middleware: [auth],
    },
  },
];

export default homeRoutes;
